/* eslint-disable max-len */

export default {
  "dr-now-doctor-sign-up": "Doctor Sign Up",
  "dr-now-doctor-sign-up-welcome-message": "We welcome you to Dr. Now!",
  "dr-now-doctor-sign-up-welcome-please-fill-your-data": "Please, complete the following form with your data to register your request.",
  "dr-now-doctor-sign-up-names": "Names",
  "dr-now-doctor-sign-up-names-placeholder": "Enter your names",
  "dr-now-doctor-sign-up-enter-two-or-more-names": "Enter all your names",
  "dr-now-doctor-sign-up-first-surname": "First Surname",
  "dr-now-doctor-sign-up-surname-placeholder": "Enter your first surname",
  "dr-now-doctor-sign-up-enter-your-first-surname": "Enter your first surname",
  "dr-now-doctor-sign-up-second-surname": "Second Surname",
  "dr-now-doctor-sign-up-enter-your-second-surname": "Enter your second surname",
  "dr-now-doctor-sign-up-email": "Email",
  "dr-now-doctor-sign-up-email-placeholder": "Enter your email",
  "dr-now-doctor-sign-up-enter-your-work-email": "Enter your work email",
  "dr-now-doctor-sign-up-country-code": "Code",
  "dr-now-doctor-sign-up-country": "Country",
  "dr-now-doctor-sign-up-phone-number": "Phone Number",
  "dr-now-doctor-sign-up-phone-number-placeholder": "Enter your phone number",
  "dr-now-doctor-sign-up-enter-your-phone-number": "Contact number",
  "dr-now-doctor-sign-up-password": "Password",
  "dr-now-doctor-sign-up-password-placeholder": "Enter a safe password",
  "dr-now-doctor-sign-up-enter-a-safe-password-msg": "To ensure the security of your account, create a password.",
  "dr-now-doctor-sign-up-at-least-eight-characters": "Minimum of 8 characters",
  "dr-now-doctor-sign-up-at-least-one-capital-letter": "At least one capital letter",
  "dr-now-doctor-sign-up-at-least-one-number": "At least one number",
  "dr-now-doctor-sign-up-at-least-one-special-character": "At least one special character",
  "dr-now-doctor-sign-up-password-confirmation": "Confirm Password",
  "dr-now-doctor-sign-up-password-confirmation-placeholder": "Enter the password again",
  "dr-now-doctor-sign-up-password-confirmation-msg": "Verify that your password matches",
  "dr-now-doctor-sign-up-health-professional-disclaimer-agree": "By accepting this option, I confirm that I am a health professional",
  "dr-now-doctor-sign-up-read-and-accept": "I have read and accept",
  "dr-now-doctor-sign-up-terms-and-conditions": "Terms and Conditions, Privacy Policy",
  "dr-now-doctor-sign-up-marketing-notifications-agree": "I agree to receive marketing notifications",
  "dr-now-doctor-sign-up-optional": "optional",
  "dr-now-doctor-sign-up-previous-fields-are-mandatory": "These fields are mandatory",
  "dr-now-doctor-sign-up-continue": "Sign Up",
  "dr-now-doctor-sign-up-accept": "Accept",
  "dr-now-doctor-sign-up-field-required": "Field required",
  "dr-now-doctor-sign-up-invalid-email": "Invalid email",
  "dr-now-doctor-sign-up-invalid-phone-number": "Invalid phone number",
  "dr-now-doctor-sign-up-invalid-characters": "Invalid characters",
  "dr-now-doctor-sign-up-invalid-password": "Invalid password",
  "dr-now-doctor-sign-up-passwords-must-match": "Passwords must match",
  "dr-now-doctor-sign-up-service-error": "Service error",
  "dr-now-doctor-sign-up-please-try-again-later": "Please, try again later",
  "dr-now-doctor-sign-up-processing": "Processing",
  "dr-now-doctor-sign-up-email-registered-title": "Registration error",
  "dr-now-doctor-sign-up-email-registered-message": "The email has already been registered",
  "register-completed": "Welcome!",
  "register-completed-message-1": "Thank you for joining the Dr. Now community.",
  "register-completed-message-2": "You will then receive an email with instructions to access our platform.",
  "register-completed-message-3": "We are excited for your medical practice to be part of this new way of doing medicine.",
  dashboard: "Go to dashboard",
  "go-home": "Go to home",
  "valid-country-code": "Enter a valid country code",
};
